/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  CreateMonitorMutationRequest,
  CreateMonitorMutationResponse,
  CreateMonitor400,
  CreateMonitor401,
} from '../types/CreateMonitor.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getCreateMonitorUrl() {
  const res = { method: 'POST', url: `/v1/monitors` as const };
  return res;
}

/**
 * @summary Create a monitor
 * {@link /v1/monitors}
 */
export async function createMonitor(
  data: CreateMonitorMutationRequest,
  config: Partial<RequestConfig<CreateMonitorMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    CreateMonitorMutationResponse,
    ResponseErrorConfig<CreateMonitor400 | CreateMonitor401>,
    CreateMonitorMutationRequest
  >({ method: 'POST', url: getCreateMonitorUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
